import React from 'react'
import { Grid, Hidden, Input, InputLabel, MenuItem, Select, FormGroup, FormLabel, FormControl, FormControlLabel, FormHelperText, Checkbox, ListItemText } from '@material-ui/core'
import { IconButton, Tooltip } from '@michelin/acid-components'
import { Delete as DeleteIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons'
import MaterialInputable from './MaterialInputable'
import MaterialPhone from './MaterialPhone'
import FormValidator from './FormValidator'
import PropTypes from 'prop-types'

// const styles = theme => ({
// 	formControl: {
// 		marginLeft: 0,
// 		marginRight: 0,
// 	},
// 	button: {
// 		margin: theme.spacing.unit,
// 	},
// })

const contactTypesCodes = {
	primaryFleet: 'Primary Fleet',
	secondaryFleet: 'Secondary Fleet',
	primaryTire: 'Primary Tire PO',
	secondaryTire: 'Secondary Tire PO',
	primaryNotification: 'Primary Notification',
	secondaryNotification: 'Secondary Notification',
}

class Contact extends React.Component {
	constructor(props) {
		super(props)

		this.validator = this.getValidator(props)

		this.state = {
			validation: this.validator.valid(),
		}

		this.isValid = this.isValid.bind(this)
		this.onContactNameChange = this.onContactNameChange.bind(this)
		this.onContactTypeChange = this.onContactTypeChange.bind(this)
		this.onContactPhoneNumberChange = this.onContactPhoneNumberChange.bind(this)
		this.onContactEmailChange = this.onContactEmailChange.bind(this)
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {FormValidator} the current validation object
	 * @public
	 */
	getValidator() {
		return new FormValidator([
			{
				prop: {
					object: 'domain',
					name: 'contactPrimaryName'
				},
				field: "contactPrimaryName",
				method: 'isEmpty',
				validWhen: false,
				message: 'Contact Name is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete
			},
			{
				prop: {
					object: 'domain',
					name: 'contactTypes'
				},
				field: "contactTypes",
				method: 'isEmpty',
				validWhen: false,
				message: 'Contact Type is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete
			},
			{
				prop: {
					object: 'domain',
					name: 'contactPhoneNumber'
				},
				field: "contactPhoneNumber",
				method: 'isEmpty',
				validWhen: false,
				message: 'Phone Number is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete ||
					! this.hasContactType(this.props.domain.contactTypes, [contactTypesCodes.primaryFleet, contactTypesCodes.secondaryFleet, contactTypesCodes.primaryTire, contactTypesCodes.secondaryTire])
			},
			{
				prop: {
					object: 'domain',
					name: 'contactPhoneNumber'
				},
				field: "contactPhoneNumber",
				method: this.isMobilePhoneExtension,
				validWhen: true,
				args: ['en-US'],
				message: 'Phone Number is invalid',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete ||
					!this.hasContactType(this.props.domain.contactTypes, [contactTypesCodes.primaryFleet, contactTypesCodes.secondaryFleet, contactTypesCodes.primaryTire, contactTypesCodes.secondaryTire])
			},
			{
				prop: {
					object: 'domain',
					name: 'contactEmail'
				},
				field: "contactEmail",
				method: 'isEmpty',
				validWhen: false,
				message: 'Email is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete ||
					! this.hasContactType(this.props.domain.contactTypes, [contactTypesCodes.primaryNotification, contactTypesCodes.secondaryNotification])
			},
			{
				prop: {
					object: 'domain',
					name: 'contactEmail'
				},
				field: "contactEmail",
				method: 'isEmail',
				validWhen: true,
				message: 'Email is invalid',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete ||
					!this.hasContactType(this.props.domain.contactTypes, [contactTypesCodes.primaryNotification, contactTypesCodes.secondaryNotification])
			},
			{
				prop: {
					object: 'domain',
					name: 'dispatchedNotification'
				},
				field: 'notifications',
				method: this.hasOneChecked,
				args: ['props.domain.dispatchedNotification', 'props.domain.vehicleRollingNotification'],
				validWhen: true,
				message: 'A Notification is required',
				isDisabled: this.props.disabled || this.props.domain.readOnly || this.props.domain.isDelete ||
					! this.hasContactType(this.props.domain.contactTypes, [contactTypesCodes.primaryNotification, contactTypesCodes.secondaryNotification])
			},
		])
	}


	/**
	 * Checks if the value is a valid phone number with extension
	 * @param {array} value - the current value
	 * @param {array} args - the list of all elements to be checked
	 * @returns {boolean} Is the phone number valid with an optional extension?
	 * @public
	 */
	isMobilePhoneExtension(value, ...args) {
		const phone = /^(\+?1?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})(( |-)?(x|ext|extension)?[ ]?[0-9]{1,5})?$/

		return phone.test(value)
	}

	/**
	 * Checks if one of the elements is checked
	 * @param {array} value - the current value
	 * @param {array} args - the list of all elements to be checked
	 * @returns {boolean} Does the list contain at least one checked element?
	 * @public
	 */
	hasOneChecked(value, ...args) {
		const state = args[args.length - 2]
		const props = args[args.length - 1]

		const values = args.map(item => {
			if (typeof item === 'string') {
				const parts = item.split('.')

				if (parts.length > 1) {
					if (parts[0] === 'props') {
						return parts.length === 2 ? props[parts[1]] : props[parts[1]][parts[2]]
					} else {
						return parts.length === 2 ? state[parts[1]] : state[parts[1]][parts[2]]
					}
				}
			}

			return false
		}).filter(item => item !== undefined && item === true)

		return values.length > 0
	}

	/**
	 * Checks if one of the contactTypes are in the list
	 * @param {array} contactTypes - an array of contact types
	 * @param {array} list - the list of all values
	 * @returns {boolean} Does the list contain at least one contactTypes?
	 * @public
	 */
	hasContactType(contactTypes, list) {
		let result = false

		contactTypes.forEach( item => {
			if( list.includes(item) )
				result = true
		})
		return result
	}

	/**
	 * Update the validation object value for 'item'
	 * @param {array} items - the item in the validation object to update
	 * @param {boolean} isInvalid - the new state for isInvalid
	 * @param {string} message - the new message to be displayed
	 * @returns {void} returns void
	 * @public
	 */
	updateValidation(items, isInvalid = false, message = '') {
		let validation = Object.assign({}, this.state.validation)
		items = Array.isArray(items) ? items : [items]

		items.forEach(item => {
			validation[item].isInvalid = isInvalid
			validation[item].message = message
		})

		this.setState({
			validation: validation
		})
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onContactNameChange(event) {
		this.updateValidation('contactPrimaryName')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onContactTypeChange(event) {
		this.updateValidation(['contactPrimaryName', 'contactPhoneNumber', 'contactEmail', 'notifications'])

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onContactPhoneNumberChange(event) {
		this.updateValidation('contactPhoneNumber')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onContactEmailChange(event) {
		this.updateValidation('contactEmail')

		if (this.props.onChange) {
			this.props.onChange(event)
		}
	}

	/**
	 * The onChange event for the otherType
	 * @param {event} event - the event object
	 * @returns {void} returns void
	 * @public
	 */
	onNotificationsChange(event) {
		this.updateValidation('notifications')

		if (this.props.onChangeSelect) {
			this.props.onChangeSelect(event)
		}
	}

	/**
	 * Performs validation of the data in the dialog.
	 * @returns {boolean} is the current object valid?
	 * @public
	 */
	async isValid() {
		this.validator = this.getValidator()

		const validation = await this.validator.validate(this.state, this.props)
		this.setState({ validation })

		return validation.isValid
	}

	render() {
		const { index, disabled, domain, contactTypes, onRemove, onChange, onChangeSelect } = this.props
		const { validation } = this.state

		if (domain.isDelete) {
			return null
		} 

		this.validator = this.getValidator()

		return (
			<Grid container spacing={1} style={domain.isCreate ? ((index % 2 === 1) ? { background: '#faf8cd' } : { background: '#fffee9' }) : (index % 2 === 1) ? { background: '#efefef' } : null}>
				<Grid item xs={12} sm={4} md={3} lg={2}>
					<MaterialInputable
						required 
						name={index + "_contactPrimaryName"} 
						label="Contact Name"
						value={domain.contactPrimaryName || ''} 
						error={validation.contactPrimaryName.isInvalid}
						errorMessage={validation.contactPrimaryName.message}
						onChange={this.onContactNameChange} 
						disabled={disabled || domain.readOnly} />
				</Grid>

				<Grid item xs={12} sm={8} md={9} lg={4}>
					<FormControl fullWidth error={validation.contactTypes.isInvalid}>
						<InputLabel htmlFor="select-multiple-chip">Contact Type *</InputLabel>
						<Select
							multiple
							disabled={disabled || domain.readOnly}
							name={index + "_contactTypes"}
							value={domain.contactTypes || ''}
							onChange={this.onContactTypeChange}
							input={<Input id="select-multiple-chip" />}
							renderValue={selected => selected.join(', ')}
						>
							{contactTypes.map(contactType => ( 
								<MenuItem key={contactType.name} value={contactType.name}>
									<Checkbox color="primary" checked={domain.contactTypes.indexOf(contactType.name) !== -1} />
									<ListItemText primary={contactType.name} />
								</MenuItem>
							))}
						</Select>
						<FormHelperText>{validation.contactTypes.message}</FormHelperText>
					</FormControl>
				</Grid>

				<Grid item xs={6} sm={4} md={3} lg={1}>
					<MaterialInputable 
						disabled={disabled || domain.readOnly} 
						name={index + "_contactTitle"} 
						label="Title" 
						value={domain.contactTitle || ''}
						onChange={onChange} />
				</Grid>

				<Grid item xs={6} sm={4} md={3} lg={2}>
					<MaterialPhone
						extension
						required={this.hasContactType(domain.contactTypes, [contactTypesCodes.primaryFleet, contactTypesCodes.secondaryFleet, contactTypesCodes.primaryTire, contactTypesCodes.secondaryTire])}
						disabled={disabled || domain.readOnly} 
						name={index + "_contactPhoneNumber"} 
						label="Phone Number" 
						value={domain.contactPhoneNumber || ''}
						error={validation.contactPhoneNumber.isInvalid}
						errorMessage={validation.contactPhoneNumber.message}
						onChange={this.onContactPhoneNumberChange} />
				</Grid>

				<Grid item xs={12} sm={4} md={4} lg={2}>
					<MaterialInputable 
						required={this.hasContactType(domain.contactTypes, [contactTypesCodes.primaryNotification, contactTypesCodes.secondaryNotification])}
						disabled={disabled || domain.readOnly} 
						name={index + "_contactEmail"} 
						label="Email" 
						type="email"
						value={domain.contactEmail || ''}
						error={validation.contactEmail.isInvalid}
						errorMessage={validation.contactEmail.message}
						onChange={this.onContactEmailChange} />
				</Grid>

				<Hidden smDown>
					<Grid item xs={3} md={2} lg={1}>
						{!(disabled || domain.readOnly) &&
							<Tooltip title="Delete">
								<IconButton aria-label="Delete" onClick={() => onRemove(index)} color="primary" disabled={domain.readOnly}>
									<DeleteIcon />
								</IconButton>
							</Tooltip>
						}

						{process.env.NODE_ENV !== 'production' &&
							<Tooltip title="Validate">
								<IconButton aria-label="Validate" onClick={this.isValid} color="primary">
									<CheckCircleIcon />
								</IconButton>
							</Tooltip>
						}
					</Grid>
				</Hidden>

				<Grid item xs={8} md={6} lg={4}>
					<FormControl required={this.hasContactType(domain.contactTypes, [contactTypesCodes.primaryNotification, contactTypesCodes.secondaryNotification])} error={validation.notifications.isInvalid}>
						<FormLabel component="legend">Notifications</FormLabel>

						<FormGroup row>
							<FormControlLabel
								label="Dispatched Notification"
								control={
									<Checkbox
										color="primary"
										disabled={disabled || domain.readOnly}
										name={index + "_dispatchedNotification"}
										checked={domain.dispatchedNotification}
										onChange={onChangeSelect} />
								} />

							<FormControlLabel
								label="Vehicle Rolling Notification"
								control={
									<Checkbox
										color="primary"
										disabled={disabled || domain.readOnly}
										name={index + "_vehicleRollingNotification"}
										checked={domain.vehicleRollingNotification}
										onChange={onChangeSelect} />
								} />
						</FormGroup>

						<FormHelperText>{validation.notifications.message}</FormHelperText>
					</FormControl>
				</Grid>

				<Hidden mdUp>
					<Grid item xs={2}>
						{!(disabled || domain.readOnly) &&
							<Tooltip title="Delete">
								<IconButton aria-label="Delete" onClick={() => onRemove(index)} color="primary" disabled={domain.readOnly}>
									<DeleteIcon />
								</IconButton>
							</Tooltip>
						}

						{process.env.NODE_ENV !== 'production' &&
							<Tooltip title="Validate">
								<IconButton aria-label="Validate" onClick={this.isValid} color="primary">
									<CheckCircleIcon />
								</IconButton>
							</Tooltip>
						}
					</Grid>
				</Hidden>
			</Grid>
		)
	}
}

Contact.propTypes = {
	classes: PropTypes.object,
	index: PropTypes.number,
	disabled: PropTypes.bool,
	domain: PropTypes.object,
	onRemove: PropTypes.func,
	onChange: PropTypes.func,
	onChangeSelect: PropTypes.func,
	contactTypes: PropTypes.array
}

Contact.defaultProps = {
	disabled: false,
	contactTypes: [],
}

export default Contact


// WEBPACK FOOTER //
// ./src/components/Contact.js